// https://vuex.vuejs.org/en/modules.html
import camelCase from "lodash/camelCase";

const requireModule = require.context('.', true, /\.js$/)
const modules = {}

requireModule.keys().forEach(fileName => {
  if (fileName === './index.js') return

  // Replace ./ and .js
  const path = fileName.replace(/(\.\/|\.js)/g, '')
  let p = path.split('/')
  const imported = p.pop()
  if (p.length > 1){
    p = p.join('/')
  }
  const moduleName = p
  //const [moduleName, imported] = path.split('/')

  if (!modules[moduleName]) {
    modules[moduleName] = {
      namespaced: true
    }
  }
  modules[moduleName][imported] = requireModule(fileName).default
})

export default modules
